module.exports = __webpack_public_path__ + "static/media/whitelabel-solutions-bg.ced258de.jpg";